import { useState } from "react";
import { Reactable } from "../../components/ui/reactable";
import { ReportPageShell } from "../../components/ui/reportPageShell";
import { SALARYPROCESS_BANK_REPORTS } from "../../constants/api";
import { EmployeeDetails } from "../../components/ui/cards";

const SalaryProcessBank = () => {

    const [salaryProcessBankData, setSalaryProcessBankData] = useState([]);
    const [totalRecords, setTotalRecords] = useState(0);
        const salaryProcessBankColumns = [
        {
            accessor: "employee_name",
            Header: "Employee",
            sortable: true,
            fixed: true,
            filterable: true,
            maxWidth: "300px",
            Cell: ({ value, row }) => {
                const record = row;

                let empDetails = {
                    ...record?.employee,
                    designation_id: record?.employee?.designation
                        ? {
                            id: record?.employee.designation.id,
                            designation_name: record?.employee.designation.name,
                        }
                        : { id: 0, designation_name: "" },
                    first_name: record?.employee?.employee_name || "-",
                    id: record?.employee?.employee_id || "-",
                };

                return <EmployeeDetails details={empDetails} size="xs" />;
            },
        },
        {
            accessor: "bank_name",
            Header: "Bank Name",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "ifsc_code",
            Header: "IFSC Code",
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "Account_no",
            Header: "Account No",
            filterable: true,
            Cell: ({ value }) => value ?? "-",
        },
        {
            accessor: "take_home",
            Header: "Take Home",
            Cell: ({ value }) => value ?? "-",
        }
    ];

    return (
        <ReportPageShell title="Salary Process Bank Report " count={totalRecords}>

            <Reactable
                columns={salaryProcessBankColumns}
                data={salaryProcessBankData}
                setData={setSalaryProcessBankData}
                setTotalCount={setTotalRecords}
                url={SALARYPROCESS_BANK_REPORTS}
                serverSide={true}
                rowSize="sm"
                isCSVRequired={true}
                isPDFRequired={true}
                isMonthYearRequired={true}
            />
        </ReportPageShell>
    );
}

export default SalaryProcessBank;